import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingState,
  setModalTitle,
} from "../../../redux/features/settingSlice";
import FollowModal from "../FollowModal";
import ParticipantsModal from "../ParticipantsModal";
import PlayListModal from "../PlayListModal";
import ReportModal from "../ReportModal";
import HomeScreenModal from "../HomeScreenModal";

const ModalList = () => {
  const { modalType } = useSelector(getSettingState);
  const dispatch = useDispatch();

  useEffect(() => {
    modalType !== "Participants" && dispatch(setModalTitle(null));
  }, [dispatch, modalType]);
  return (
    <>
      {(modalType === "Followers" || modalType === "Following") && (
        <FollowModal />
      )}
      {modalType === "Participants" && <ParticipantsModal />}
      {modalType === "PlayList" && <PlayListModal />}
      {modalType === "Report" && <ReportModal />}
      {modalType === "Azad" && <HomeScreenModal />}
    </>
  );
};

export default ModalList;
